export default "__VITE_ASSET__DB20cXnp__"